import React from "react";
import { withRouter } from "react-router-dom";

import "./ChatWidgetMainView.css";
import "animate.css";

import { ChatWidgetMainViewHeader } from "../ChatWidgetMainView";
import ChatWidgetMainViewContent from "./ChatWidgetMainViewContent";
// import { ChatButton } from "../../assets/Svg-icons";
import { PostMessageType, ChatMessageType, MessageSenderType } from "../../constants";
import { WidgetPosition } from "../../constants/WidgetViews";
import PostMessageContext from "../../context/PostMessageContext";
import { MinimizedView } from "../../constants/WidgetViews";
import { scrollToBottom } from "../../utils/scrollUtils";
import { getParams } from "../../utils/commonUtil";

class ChatWidgetMainView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chatWidget: false,
            widgetIntegrated: false,
            showMenu: false,
            showEmailContainer: false,
            showEmailSuccessMessage: false,
            showEndConversationContainer: false,
            showOptionsContainer: false,
            chatButtonClass: "heartBeat",
            agentJoined: false,
            emailForm: false,
            chatResolved: false,
            agentsOffline: false,
            messageData: [],
            messageDataAvailable: true,
            agentData: {},
            chatData: {},
            typing: false,
            iframeParentUrl: "",
            iframeEnv: "",
            messageLoading: false,
            showDownButton: false,
            isNewMessage: false,
            newMessagesCount: 0,
            unseenMessages: 0,
            visitorId: null,
            chatId: null,
            widgetOpenHit: false,
            botAvatar: "",
            isAgentOffline: true,
            chatInitialize: true,
            widgetSettings: {
                Appearance: {},
                Behaviour: {}
            },
            IsBotEnable: false,
            BotName:"",
            currentlyActiveAgents:null,
            isTriggeredMessagesSet: false
            // chatBotOpenMessagesExist:null
        };
        this.messageInfo = {}
    }

    componentDidMount() {
        let params = getParams();
        if (params) {
            const parentUrl = params["origin"];
            const iframeEnv = params["iframeEnv"];
            const widgetIntegrated = params["widgetIntegrate"];
            this.setState(
                {
                    messageData: [],
                    iframeParentUrl: parentUrl,
                    iframeEnv,
                    widgetIntegrated: widgetIntegrated
                },
                () => {
                    this.IframePostMessage({ Message: PostMessageType.IframeLoaded });
                    if(widgetIntegrated){
                        this.openChatWidget()
                    }
                }
            );
            this.messageInfo = this.state.chatInitialize ? this.messageInfo : {}
        }
        window.addEventListener("message", this.widgetEvents, false);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.widgetEvents, false);
    }

    IframePostMessage = (object) => {
        object["iframeEnv"] = this.state.iframeEnv;
        object = JSON.stringify(object);
        window.parent.postMessage(object, this.state.iframeParentUrl);
    };

    widgetEvents = (event) => {
        if (event.origin !== this.state.iframeParentUrl) {
            return;
        }
        let data = event.data;
        if (typeof data === "string") {
            try {
                data = JSON.parse(data);
            } catch (err) {
                return;
            }
        }

        switch (data.Message) {
            case PostMessageType.Init:
                this.initWidget(data.Data);
                break;
            case PostMessageType.GetState:
                // this.sendWidgetState();
                break;
            case PostMessageType.WidgetOpen:
                this.openChatWidget();
                break;
            case PostMessageType.WidgetClose:
                this.closeChatWidget();
                break;
            case PostMessageType.TypingHint:
                this.handleTypingHint(data.Data);
                break;
            case PostMessageType.HideChatForm:
                this.hideChatForm();
                break;
            case PostMessageType.ShowChatForm:
                this.showChatForm();
                break;
            case PostMessageType.WidgetOffline:
                this.widgetOffline(data.Data);
                break;
            case PostMessageType.SetOfflineAgents:
                this.setOfflineAgents(data.Data)
                // this.widgetOffline(data.Data);
                break;
            case PostMessageType.RenderMessage:
                this.getMessage(data);
                break;
            case PostMessageType.MessageLoading:
                this.handleMessageLoading(data);
                break;
            case PostMessageType.AgentJoined:
                this.handleAgentJoined(data);
                break;
            case PostMessageType.BotAvatar:
                this.handleBotAvatar(data);
                break;
            case PostMessageType.EmailSendSuccess:
                this.handleEmailSendSuccess();
                break;
            case PostMessageType.EmailSendPending:
                this.handleEmailPending();
                break;
            case PostMessageType.ChatResolved:
                this.handleChatResolved();
                break;
            case PostMessageType.SetChatId:
                this.setChatId(data.Data);
                break;
            case PostMessageType.SetCookies:
                this.setCookies(data.Data);
                break;
            case PostMessageType.ChatData:
                this.setChatData(data.Data);
                break;
            case PostMessageType.UpdateMessageId:
                this.updateAcknowledgedMessageId(data.Data);
                break;
            case PostMessageType.UpdateNewMessageCount:
                this.updateNewMessageCount(data.Data);
                break;
            case PostMessageType.ChatBotEnabled:
                this.updateChatBotStatus(data.Data)
                break;
            default:
                break;
        }
    };

    getMessage = (data) => {
        data.Data.PrimaryKey = data.Data.Id || data.Data.ChatEventId || data.Data.MessageUUID || data.Data.EventType;

        let { messageData } = this.state;
        if(!messageData){
            messageData = []
        }

        const newMessage = [...messageData]
        if (data.Data.atStart) {
            if(data.Data.PrimaryKey && !this.messageInfo[data.Data.PrimaryKey]){
                newMessage.unshift(data);
                this.setState({ isNewMessage: false });
                this.messageInfo[data.Data.PrimaryKey] = 1
            }
        } else {
            if(((data.Data.PrimaryKey && (!this.messageInfo[data.Data.PrimaryKey])) || (data.Data.EventType === ChatMessageType.AgentJoined || data.Data.EventType === ChatMessageType.ChatResolved || data.Data.EventType === ChatMessageType.AgentLeft || data.Data.EventType === ChatMessageType.Message || data.Data.EventType === ChatMessageType.ChatStarted))){
                newMessage.push(data);
                this.setState({ isNewMessage: true });
                if (this.state.showDownButton && data.Data.EventType === ChatMessageType.Message) {
                    this.setState((state) => ({ unseenMessages: state.unseenMessages + 1 }));
                }
                this.messageInfo[data.Data.PrimaryKey] = 1
            }
        }
        this.setState({ messageData: newMessage }, () => {
            if (
                !data.Data.atStart &&
                (data.Data.SenderType === MessageSenderType.Visitor || !this.state.showDownButton)
            ) {
                scrollToBottom();
            }
        });

        if (data.Data.EventType === ChatMessageType.ChatStarted) {
            this.setState({ messageDataAvailable: false });
        }
    };

    setChatId = (chatId) => {
        this.setState({ chatId });
    };

    setChatData = (chatData) => {
        this.setState({ chatData });
    };

    setCookies = (cookies) => {
        this.setState({ visitorId: cookies });
    };

    handleAgentJoined = (data) => {
        this.setState({ agentJoined: true, agentData: data.Data, IsBotEnable: false, isAgentOffline: false, emailForm: false });
    };

    handleBotAvatar = (data) => {
        this.setState({ botAvatar: data.Data });
    };

    updateAcknowledgedMessageId = (data) => {
        const { messageData } = this.state;
        messageData.forEach((msg) => {
            if (msg.Data.MessageUUID === data.MessageUUID) {
                msg.Data["Id"] = data.messageId;
            }
        });
        this.setState({ messageData });
    };

    updateNewMessageCount = (data) => {
        let {chatWidget} = this.state
        if(!chatWidget){
            this.openChatWidget()
        }
        this.setState({ newMessagesCount: data });
    };

    updateChatBotStatus = (data) => {
        this.setState({IsBotEnable: data.chatBotEnabled, BotName: data.botName, emailForm: false})
    }

    handleTypingHint(typing) {
        this.setState({ typing, ...(typing && { isNewMessage: typing }) }, () => {
            if (typing && !this.state.showDownButton) {
                scrollToBottom();
            }
        });
    }

    initWidget = (data) => {
        // this.setState({ iframeParentUrl: data.origin, widgetSettings: data.settings, isTriggeredMessagesSet: !!data.chatBot.filter(botMessage => (botMessage.Type == 40 || botMessage.Type == 10)).length});
        this.setState({ iframeParentUrl: data.origin, widgetSettings: data.settings});
    };

    sendWidgetState = () => {
        // this.IframePostMessage({ Message: PostMessageType.GetState, State: this.state.chatWidget });
    };

    setOfflineAgents = (data) => {
        this.setState({currentlyActiveAgents: data})
    }

    widgetOffline = (isOffline) => {
        this.setState({ ...(isOffline && { agentJoined: false }), agentsOffline: isOffline });
        if(!isOffline){
            this.setState({
                isAgentOffline: false
            })  
        }
    };

    handleChatResolved = () => {
        this.setState({ widgetOpenHit: false, chatResolved: true });
    };

    hideChatForm = () => {
        this.setState({ emailForm: false });
    };

    showChatForm = () => {
        this.setState({ emailForm: true, agentJoined: false });
    };

    openChatWidget = () => {
        this.setState({
            chatWidget: true,
            chatButtonClass: "fadeInUp",
            messageData: this.state.chatInitialize ? this.state.messageData : [],
            messageDataAvailable: true,
            typing: false,
            isNewMessage: false,
            newMessagesCount:0,
            unseenMessages: 0,
            showDownButton: false,
            agentJoined: false,
            chatResolved: false
        });
        this.messageInfo = this.state.chatInitialize ? this.messageInfo : {}
        if (!this.state.widgetOpenHit) {
            this.IframePostMessage({ Message: PostMessageType.WidgetOpen });
            this.setState({ widgetOpenHit: true });
        }
    };

    closeChatWidget = () => {
        if (!this.state.widgetIntegrated) {
            this.setState({
                chatWidget: false,
                showOptionsContainer: false,
                chatInitialize: false
            });
            this.IframePostMessage({ Message: PostMessageType.WidgetClose });
            this.setState({ widgetOpenHit: false });
        }
    };

    resolveChatWidget = () => {
        this.setState({ widgetOpenHit: false });
    };

    handleEmailSendSuccess = () => {
        this.setState({
            showOptionsContainer: true,
            showEmailSuccessMessage: true,
            showEmailContainer: false,
            showEndConversationContainer: false
        });
    };

    handleEmailPending = () => {
        this.setState({
            showOptionsContainer: true,
            showEmailContainer: true,
            showEmailSuccessMessage: false,
            showEndConversationContainer: false
        });
    };

    handleEmailSendClick = (Email) => {
        this.IframePostMessage({ Message: PostMessageType.EmailSendConfirm, Data: Email });
    };

    handleEmailMessageClick = () => {
        if (!this.state.emailForm) {
            this.IframePostMessage({ Message: PostMessageType.EmailSendClick });
        }
    };

    handleContainerCancelClick = (e) => {
        e && e.preventDefault();
        this.setState({
            showOptionsContainer: false
        });
    };

    handleMessageLoading = (data) => {
        this.setState({ messageLoading: data.Data });
    };

    handleMenuClick = () => {
        this.setState({ showMenu: true });
        this.bindDocumentLister();
    };

    bindDocumentLister = () => {
        document.getElementById("root").addEventListener("click", this.documentClick, false);
    };

    unbindDocumentLister = () => {
        document.getElementById("root").removeEventListener("click", this.documentClick, false);
    };

    documentClick = (e) => {
        this.setState({ showMenu: false });
        this.unbindDocumentLister();
    };

    handleChatResolveClick = () => {
        if (!this.state.emailForm && !this.state.agentsOffline) {
            this.setState({
                showEndConversationContainer: true,
                showOptionsContainer: true,
                showEmailContainer: false,
                showEmailSuccessMessage: false
            });
        } else {
            this.closeChatWidget();
        }
    };

    handleBackIconClick = () => {
        if (
            window.Native &&
            window.Native.onBackPressed &&
            typeof window.Native.onBackPressed == "function"
        ) {
            window.Native.onBackPressed();
        } else if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.callbackHandler &&
            window.webkit.messageHandlers.callbackHandler.postMessage
        ) {
            window.webkit.messageHandlers.callbackHandler.postMessage("onBackPressed");
        }
    };

    handleEndConversationClick = () => {
        this.IframePostMessage({
            Message: PostMessageType.EndConversation
        });
        this.setState({
            chatWidget: false,
            showOptionsContainer: false,
            agentJoined: false,
            chatResolved: false,
            agentData: {}
        });
    };

    changeDownButtonState = (showDownButton) => {
        this.setState({ showDownButton });
    };

    changeUnseenMessagesCount = (count) => {
        this.setState({ unseenMessages: count });
    };

    handleChatStartClick = () => {
        this.IframePostMessage({ Message: PostMessageType.StartChat });
        this.setState({
            messageData: [],
            agentJoined: false,
            chatResolved: false,
            messageDataAvailable: true
        });
        this.messageInfo = this.state.chatInitialize ? this.messageInfo : {}
    };

    getChatButtonPosition = () => {
        const { widgetSettings } = this.state;

        switch (widgetSettings.Appearance.Position) {
            case WidgetPosition.Left:
                return { left: "20px" };
            case WidgetPosition.Right:
                return { right: "20px" };
            default:
                return {};
        }
    };

    renderMenu = () => {
        const { showMenu, emailForm, widgetIntegrated } = this.state;
        return (
            <div
                className={`overflow-menu ${widgetIntegrated ? "right-overflow-menu" : "left-overflow-menu"} ${showMenu ? "show" : ""}`} >
                {/* Could be use in future version */}
                {/* <div onClick={this.handleChatResolveClick} className={`overflow-content ${emailForm ? "disabled" : ""}`}>
                    Resolve Chat
                </div> */}
                <div onClick={this.handleEmailMessageClick} className={`overflow-content ${emailForm ? "disabled" : ""}`}>
                    Email Chat Transcript
                </div>
            </div>
        );
    };

    static Icon = ({ color }) => {
        return (
            <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="28px"
                height="28px"
                viewBox="0 0 612 612">
                <g>
                    <g id="_x32__26_">
                        <g>
                            <path
                                fill={color}
                                d="M401.625,325.125h-191.25c-10.557,0-19.125,8.568-19.125,19.125s8.568,19.125,19.125,19.125h191.25
                                c10.557,0,19.125-8.568,19.125-19.125S412.182,325.125,401.625,325.125z M439.875,210.375h-267.75
                                c-10.557,0-19.125,8.568-19.125,19.125s8.568,19.125,19.125,19.125h267.75c10.557,0,19.125-8.568,19.125-19.125
                                S450.432,210.375,439.875,210.375z M306,0C137.012,0,0,119.875,0,267.75c0,84.514,44.848,159.751,114.75,208.826V612
                                l134.047-81.339c18.552,3.061,37.638,4.839,57.203,4.839c169.008,0,306-119.875,306-267.75C612,119.875,475.008,0,306,0z
                                M306,497.25c-22.338,0-43.911-2.601-64.643-7.019l-90.041,54.123l1.205-88.701C83.5,414.133,38.25,345.513,38.25,267.75
                                c0-126.741,119.875-229.5,267.75-229.5c147.875,0,267.75,102.759,267.75,229.5S453.875,497.25,306,497.25z"
                            />
                        </g>
                    </g>
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
            </svg>
        );
    };

    renderChatButton = () => {
        const { chatWidget, widgetSettings, newMessagesCount } = this.state;
        const isBarViewEnabled = widgetSettings.Appearance.MinimizedView === MinimizedView.Bar;

        return (
            <div
                className={`chat-button-wrapper ${isBarViewEnabled ? "bar" : ""}`}
                style={this.getChatButtonPosition()}
            >
                <div
                    style={{
                        backgroundColor: widgetSettings.Appearance.TitleBarClosedColor,
                        // backgroundColor: "#ffffff",
                        color: widgetSettings.Appearance.TitleBarClosedTextColor
                    }}
                    className={`chat-button ${
                        !chatWidget ? this.state.chatButtonClass + " animated fast" : null
                    }`}
                    onClick={this.openChatWidget}
                >
                    <span
                        style={{
                            color: widgetSettings.Appearance.TitleBarClosedTextColor
                        }}
                    >
                        {widgetSettings.Appearance.TitleBarClosedText || "Chat Now"}{" "}
                    </span>
                    {/* <img src={ChatButton} alt="chat button" /> */}
                    <ChatWidgetMainView.Icon color={widgetSettings.Appearance.IconColor} />
                    {newMessagesCount > 0 && (
                        <div
                            className="notify-dot"
                            style={{
                                // backgroundColor: widgetSettings.Appearance.TitleBarClosedColor
                                backgroundColor: "#DF2727"
                            }}
                        >
                            {newMessagesCount.toString().padStart(2, '0')}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    renderChatWidget = () => {
        const {
            showEmailContainer,
            chatWidget,
            agentJoined,
            emailForm,
            messageData,
            agentData,
            chatData,
            typing,
            messageLoading,
            showEndConversationContainer,
            showOptionsContainer,
            showDownButton,
            unseenMessages,
            showEmailSuccessMessage,
            agentsOffline,
            chatResolved,
            messageDataAvailable,
            isNewMessage,
            widgetIntegrated,
            botAvatar,
            IsBotEnable,
            BotName,
            isAgentOffline,
            currentlyActiveAgents
        } = this.state;
        return (
            <div
                className={`chatbox-container ${
                    chatWidget && !widgetIntegrated ? "fadeInUp animated fast" : null
                } ${widgetIntegrated ? "chatbox-container-integrated" : null}`}
            >
                <div
                    className={`chatbox-wrapper-smooth ${
                        widgetIntegrated ? "chatbox-wrapper-smooth-integrated" : null
                    }`}
                    style={{
                        background:"#F6F6F7"
                    }}
                >
                    <div className="chatbox-content-wrapper">
                        <ChatWidgetMainViewHeader
                            botAvatar={botAvatar}
                            onMenuClick={this.handleMenuClick}
                            onCrossClick={this.closeChatWidget}
                            widgetIntegrated={widgetIntegrated}
                            agentsOffline={agentsOffline}
                            crossIconStyle="background:rgb(0, 108, 255)"
                            headerWrapperHeight={{
                                // emailForm
                                height: `${(agentJoined || IsBotEnable) && !(emailForm && ((this.state.widgetSettings.Behaviour.PreChatFormEnabled) || (!this.state.widgetSettings.Behaviour.ChatBotEnabled && this.state.widgetSettings.Behaviour.OfflineFormEnabled))) ? "11rem" : "5rem"}`
                                // height: "12rem"
                            }}
                            agentJoined={agentJoined}
                            agentData={agentData}
                            emailForm={emailForm}
                            isBotEnable={IsBotEnable}
                            botName={BotName}
                            onBackIconClick={this.handleBackIconClick}
                            isAgentOffline={isAgentOffline}
                        />
                        <ChatWidgetMainViewContent
                        // isTriggeredMessagesSet={isTriggeredMessagesSet}
                            currentlyActiveAgents={currentlyActiveAgents}
                            botAvatar={botAvatar}
                            isAgentOffline={isAgentOffline}
                            agentJoined={agentJoined}
                            showEmailContainer={showEmailContainer}
                            showEndConversationContainer={showEndConversationContainer}
                            showEmailSuccessMessage={showEmailSuccessMessage}
                            showOptionsContainer={showOptionsContainer}
                            emailForm={emailForm}
                            handleContainerCancelClick={this.handleContainerCancelClick}
                            onEndConversationClick={this.handleEndConversationClick}
                            onEmailChatClick={this.handleEmailSendClick}
                            messageData={messageData}
                            messageDataAvailable={messageDataAvailable}
                            typing={typing}
                            agentsOffline={agentsOffline}
                            agentData={agentData}
                            chatData={chatData}
                            chatResolved={chatResolved}
                            handleChatStartClick={this.handleChatStartClick}
                            messageLoading={messageLoading}
                            showDownButton={showDownButton}
                            changeDownButtonState={this.changeDownButtonState}
                            unseenMessages={unseenMessages}
                            changeUnseenMessagesCount={this.changeUnseenMessagesCount}
                            isNewMessage={isNewMessage}
                            resolveChatWidget={this.resolveChatWidget}
                            isBotEnable={IsBotEnable}
                        />
                    </div>
                    {this.renderMenu()}
                </div>
            </div>
        );
    };

    render() {
        const { chatWidget, widgetSettings, chatId, visitorId } = this.state;
        return Object.keys(widgetSettings.Appearance).length > 0 ? (
            <div id="chat-app">
                <PostMessageContext.Provider
                    value={{
                        IframePostMessage: this.IframePostMessage,
                        widgetSettings: widgetSettings,
                        visitorData: { chatId, visitorId }
                    }}
                >
                    {chatWidget ? this.renderChatWidget() : this.renderChatButton()}
                </PostMessageContext.Provider>
            </div>
        ) : null;
    }
}

export default withRouter(ChatWidgetMainView);
